import * as tslib_1 from "tslib";
import { SoilAnalysisUploadStore } from './soil-analysis-upload.store';
import { SoilAnalysisUploadQuery } from './soil-analysis-upload.query';
import { guid, transaction } from '@datorama/akita';
import { getShareStateEntity } from '../../_shared/models/share-state-entity.model';
import { from, of, Subject } from 'rxjs';
import { catchError, concatMap, filter, tap } from 'rxjs/operators';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { SoilAnalysisFileStatus } from './constants/soil-analysis-file-status';
import * as i0 from "@angular/core";
import * as i1 from "./soil-analysis-upload.store";
import * as i2 from "./soil-analysis-upload.query";
import * as i3 from "@angular/common/http";
var SoilAnalysisUploadService = /** @class */ (function () {
    function SoilAnalysisUploadService(soilAnalysisUploadStore, soilAnalysisUploadQuery, http) {
        this.soilAnalysisUploadStore = soilAnalysisUploadStore;
        this.soilAnalysisUploadQuery = soilAnalysisUploadQuery;
        this.http = http;
        this.showInfoBox = new Subject();
        this.showInfoBox$ = this.showInfoBox.asObservable();
        this.updateStatus = new Subject();
        this.updateStatus$ = this.updateStatus.asObservable();
        this.fileExtensions = ['.zip'];
        this.fileSizeLimit = 50 * 1e+6;
    }
    SoilAnalysisUploadService.prototype.toggleInfoBox = function (show) {
        this.showInfoBox.next(show);
    };
    SoilAnalysisUploadService.prototype.addFiles = function (files) {
        var _this = this;
        this.resetStore();
        this.updateStatus.next();
        this.showInfoBox.next(true);
        var fileList = Array.from(files);
        var filesDataList = fileList.map(function (f, index) {
            var id = guid();
            var data = { name: f.name, size: f.size, status: SoilAnalysisFileStatus.Processing, index: index };
            var error = _this.validateFile(f);
            return getShareStateEntity(id, data, !error, error);
        });
        this.soilAnalysisUploadStore.add(filesDataList);
        // send files
        from(filesDataList).pipe(filter(function (item) { return !item.error; }), concatMap(function (item) { return _this.uploadFile(fileList[item.data.index], item.id); })).subscribe();
    };
    SoilAnalysisUploadService.prototype.validateFile = function (file) {
        var extension = file.name.slice(file.name.lastIndexOf('.'));
        var invalidExtensions = !this.fileExtensions.includes(extension);
        var invalidSize = !file.size || file.size > this.fileSizeLimit;
        if (invalidExtensions) {
            return 'invalidExtensions';
        }
        else if (invalidSize) {
            return 'invalidSize';
        }
        return null;
    };
    SoilAnalysisUploadService.prototype.uploadFile = function (file, id) {
        var formData = new FormData();
        formData.append('file', file);
        return this.http.post(environment.apiRoot + "/agriscouting/api/analyzes/single?fileId=" + id, formData).pipe(tap(function (response) { }), catchError(function () {
            // if (this.soilAnalysisUploadQuery.getEntity(id)) {
            //   const data = this.soilAnalysisUploadQuery.getEntity(id).data;
            //   this.soilAnalysisUploadStore.update(
            //     id,
            //     getShareStateEntity(id,
            //       {...data, status: error.status ? SoilAnalysisFileStatus.Error : SoilAnalysisFileStatus.Processing}, false,
            //       error.status === 400 ? error.error.message : (error.status === 0 ? 'cors_error' : error.status)
            //     )
            //   );
            //   return of(null);
            // }
            return of(null);
        }));
    };
    SoilAnalysisUploadService.prototype.getStatusFile = function () {
        var _this = this;
        var filesId = this.soilAnalysisUploadQuery.getAll()
            .filter(function (file) { return file.data.status === SoilAnalysisFileStatus.Processing || file.data.status === SoilAnalysisFileStatus.Error; })
            .map(function (file) { return file.id; });
        this.http.post(environment.apiRoot + "/agriscouting/api/analyzes/statusFile", filesId)
            .subscribe(function (res) {
            _this.updateStatus.next();
            res.forEach(function (item) {
                _this.soilAnalysisUploadStore.update(item.id, getShareStateEntity(item.id, tslib_1.__assign({}, item, { name: item.fileName })));
            });
        });
    };
    SoilAnalysisUploadService.prototype.resetStore = function () {
        this.soilAnalysisUploadStore.reset();
    };
    SoilAnalysisUploadService.ngInjectableDef = i0.defineInjectable({ factory: function SoilAnalysisUploadService_Factory() { return new SoilAnalysisUploadService(i0.inject(i1.SoilAnalysisUploadStore), i0.inject(i2.SoilAnalysisUploadQuery), i0.inject(i3.HttpClient)); }, token: SoilAnalysisUploadService, providedIn: "root" });
    tslib_1.__decorate([
        transaction(),
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Array]),
        tslib_1.__metadata("design:returntype", void 0)
    ], SoilAnalysisUploadService.prototype, "addFiles", null);
    return SoilAnalysisUploadService;
}());
export { SoilAnalysisUploadService };
